var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "alert alert-info holidays-alert" }, [
    _vm.editable
      ? _c("div", { staticClass: "holidays-alert__edit-delete-panel" }, [
          _c("i", {
            staticClass: "fa fa-pencil color-dark-blue pointer",
            on: { click: _vm.onEdit },
          }),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-trash-o color-red pointer",
            on: { click: _vm.onDelete },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("strong", [_vm._v("Holiday!")]),
    _vm._v(" "),
    _c("div", {}, [
      _vm._v(
        "\n        Repeated Events in this Group are canceled due to the "
      ),
      _vm.holiday.name
        ? _c("strong", [_vm._v(_vm._s(_vm.holiday.name))])
        : _vm._e(),
      _vm._v("\n        Holiday\n        between "),
      _c("strong", [_vm._v(_vm._s(this.holiday.start))]),
      _vm._v(" and\n        "),
      _c("strong", [_vm._v(_vm._s(this.holiday.end))]),
      _vm._v(".\n    "),
    ]),
    _vm._v(" "),
    _c("div", {}, [
      _c("i", [
        _vm._v(
          "\n            " + _vm._s(_vm.holiday.description) + "\n        "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "holidays-alert__created-label" },
      [
        _vm._v("\n        Created by\n        "),
        _c("simple-link", { attrs: { target: _vm.holiday.created_by } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }